import { NavLink } from 'react-router';
import { QUOTE_TOKEN_RESOURCE_ADDRESS, QUOTE_TOKEN_SYMBOL, classNames, getIconUrl, onIconError, prettyValue, roundALR } from '~/lib/util';
import PopoverAPY from './popover-apy';
import { LiquidityPositionRow } from './liquidity-position-row';
import { DataBlock } from "./data-block";

export function MyLiquidity({ pairs }) {
	return pairs.length ? (
    <div className="grow">
      <dl className="lg:items-top mb-4 flex flex-col space-y-4 lg:mb-8 lg:flex-row lg:space-x-4 lg:space-y-0">
        <DataBlock title="Total Value Locked" data={`$${prettyValue(pairs.reduce((total, r) => total + r.usdValue, 0))}`} />
        <DataBlock
          title="Total DFP2 Locked"
          data={`${prettyValue(
            pairs
              .filter((p) => p.quoteTokenAddress == QUOTE_TOKEN_RESOURCE_ADDRESS)
              .reduce((total, row) => total + row.share * (row.isBase ? row.poolState.vaults[1].amount : row.poolState.vaults[0].amount), 0),
          )} DFP2`}
        />
        <DataBlock title="Positions" data={pairs.length} />
      </dl>

      <div className="dark:bg-background-900 rounded-xl bg-white p-4 lg:rounded-2xl lg:p-8">
        <table className="min-w-full divide-y divide-gray-300">
          <thead>
            <tr>
              <th scope="col" className="pl-0 pr-3 text-left text-sm font-semibold lg:py-3.5 lg:pl-4">
                Pair
              </th>
              <th colSpan={2} scope="col" className="hidden px-3 pr-1 text-left text-sm font-semibold lg:table-cell lg:py-3.5">
                Tokens
              </th>
              <th scope="col" className="hidden px-3 pr-1 text-left text-sm font-semibold lg:table-cell lg:py-3.5">
                Share
              </th>
              <th scope="col" className="hidden px-3 pr-1 text-left text-sm font-semibold lg:table-cell lg:py-3.5">
                <PopoverAPY title="ALR" timespan="This ALR is based on the data since the creation of the pair." />
              </th>
              <th scope="col" className="relative pl-3 pr-0 lg:py-3.5 lg:pr-4"></th>
            </tr>
          </thead>
          <tbody className="divide-primary-200 lg:divide-y">
            {pairs.map((row) => (
              <LiquidityPositionRow key={row.lpToken.address} row={row} />
            ))}
          </tbody>
        </table>
      </div>
    </div>
  ) : (
    <div className="dark:bg-background-900 grow rounded-xl bg-white p-8 lg:rounded-2xl">
      <p className="text-primary-800 dark:text-primary-100 rounded-xl p-20 text-center lg:rounded-2xl">Your active liquidity positions will appear here.</p>
    </div>
  );
}
